import fetch from "isomorphic-unfetch";
// @ts-ignore
import merge from "lodash/merge";
import { getSession } from "next-auth/react";

export function encodeQueryData(data = {}) {
  const params = new URLSearchParams();
  for (const key in data) {
    const value = data[key];
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  }
  return "?" + params.toString();
}

export function tryParseJSON(json) {
  if (!json) {
    return null;
  }
  try {
    return JSON.parse(json);
  } catch (e) {
    throw new Error(`Failed to parse unexpected JSON response: ${json}`);
  }
}
const base_url = process.env.NEXT_PUBLIC_LOCAL_API_ENDPOINT;

const strapi_url = process.env.NEXT_PUBLIC_STRAPI_API;

const URLS = {
  blogs: `${base_url}blog`,
  otp: `${base_url}otp`,
  user: `${base_url}users`,
  testimonials: `${base_url}testimonials`,
  post_property: `${base_url}property`,
  builder_leads: `${base_url}builder-leads`,
  address: `${base_url}addresses`,
  furniture: `${base_url}furniture`,
  cart: `${base_url}cart`,
  furniture_leads: `${base_url}furniture-leads`,
  notifications: `${base_url}notifications`,
  servicecustomlead: `${base_url}Servicecustomlead`,
  property: `${base_url}property`,
  payment: `${base_url}payments`,
  orders: `${base_url}orders`,
  homeDecor: `${base_url}homeDecor`,
  careers: `${base_url}admin/careers`,
  apply: `${base_url}careers`,
  crmlead: `${base_url}crmlead`,
  Requestcall: `${base_url}Requestcall`,
  wishlist: `${base_url}wishlist`,
  reviews: `${base_url}reviews`,
  customBuilder: `${base_url}custom-builder`,
  customer: `${base_url}customer`,
  company: `${base_url}custom-property`,
  companyonboarding: `${base_url}companyOnboarding`,
  strapiInteriors: `${strapi_url}`,
  electronics: `${base_url}electronics`,
  company_address: `${base_url}company-address`,
  company_awards: `${base_url}company-awards`,
  delete_account: `${base_url}delete-account`,
  property_leads: `${base_url}property-leads`,
  queries: `${base_url}queries`,
  unified_listing: `${base_url}unified-listings`,
  s3bucket: `${base_url}s3bucket`,
};

const getResponseBody = (response) => {
  const contentType = response.headers.get("content-type");
  return contentType && contentType.indexOf("json") >= 0
    ? response.clone().text().then(tryParseJSON)
    : response.clone().text();
};

function ResponseError(status, response, body) {
  this.name = "ResponseError";
  this.status = status;
  this.response = response;
  this.body = body;
}
ResponseError.prototype = Error.prototype;

export const retrieveToken = async (ctx = undefined) => {
  if (ctx?.req) {
    const session = await getSession(ctx);
    // @ts-ignore
    return session?.accessToken || "";
  } else {
    const session = await getSession();
    // @ts-ignore
    return session?.accessToken || "";
  }
};

const makeHeadersAndParams = async (params, auth, type, ctx = undefined) => {
  const { headers = {}, ...restParams } = params;
  const baseHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  let headerConfig = new Headers();
  if (type !== "file") {
    headerConfig = new Headers(merge(baseHeaders, headers));
  }
  if (auth && !headerConfig.get("Authentication")) {
    const token = await getSession();
    // @ts-ignore
    headerConfig.set("Authentication", `Bearer ${token.token}`);
  }
  return {
    headers: headerConfig,
    params: restParams || {},
  };
};

const request = async ({
  url = "",
  method = "GET",
  params = {},
  auth = false,
  type,
  ctx = undefined,
}) => {
  const { headers, params: apiParams } = await makeHeadersAndParams(
    params,
    auth,
    type,
    ctx
  );
  const options = {
    method,
    headers,
  };
  if (method === "GET") {
    if (Object.keys(apiParams).length > 0) url += encodeQueryData(apiParams);
  } else {
    options["body"] = type === "file" ? params : JSON.stringify(apiParams);
  }

  return fetch(url, options).then((response) => {
    return getResponseBody(response).then((body = {}) => {
      if (response.ok) {
        return { body, status: response.status };
      } else {
        throw new ResponseError(response.status, response, body);
      }
    });
  });
};

const _request = request;

const get = (url, params, auth = false) => {
  // @ts-ignore
  return _request({
    method: "GET",
    url,
    params,
    auth,
  });
};

const post = (url, params, auth = false, type) => {
  return _request({
    method: "POST",
    url,
    params,
    auth,
    type,
  });
};

const put = (url, params, auth = false) => {
  // @ts-ignore
  return _request({
    method: "PUT",
    url,
    params,
    auth,
  });
};

const patch = (url, params, auth = false) => {
  // @ts-ignore
  return _request({
    method: "PATCH",
    url,
    params,
    auth,
  });
};

const _delete = (url, params, auth = false) => {
  // @ts-ignore
  return _request({
    method: "DELETE",
    url,
    params,
    auth,
  });
};

const apiClient = {
  URLS,
  get,
  post,
  put,
  patch,
  delete: _delete,
  raw: _request,
};

export default apiClient;
